import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  static targets = ['checkbox', 'gas', 'value', 'gasInput']

  toggleGas(event) {
    this.displayGas(event.target)
  }

  updateTotal() {
    let total = 0

    this.gasInputTargets
      .filter(t => t.value)
      .forEach(target => {
        total += Number.parseFloat(target.value)
        // The below code line deal with the floating precision issue :
        // https://stackoverflow.com/questions/1458633/how-to-deal-with-floating-point-number-precision-in-javascript
        total = Number.parseFloat(total.toPrecision(12))
      })

    this.valueTarget.value = total
  }

  displayGas(element) {
    if (element.checked) {
      this.gasTarget.classList.remove('d-none')
      this.valueTarget.readOnly = true
    } else {
      this.gasTarget.classList.add('d-none')
      this.valueTarget.readOnly = false
    }
  }
}
